/*
* Date: 20/04/2026
* Author: Vinh.Pham
* Description: A table styled with only bottom borders for each row
 */
import { Table } from 'antd';
import type { TableProps } from 'antd/es/table';
import styles from './style.module.scss';

interface IProps<T> extends TableProps<T> {
}

export default function TableUI<T>(props: IProps<T>) {
    const { rowKey = 'id', pagination = false, ...args } = props;
    return <Table
        {...args}
        rowKey={rowKey}
        className={styles.table}
        pagination={pagination}
    />
}